import { render } from "./VBottle.vue?vue&type=template&id=682142f5"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VBottle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "682142f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('682142f5', __exports__)) {
    api.reload('682142f5', __exports__)
  }
  
  module.hot.accept("./VBottle.vue?vue&type=template&id=682142f5", () => {
    api.rerender('682142f5', render)
  })

}


export default __exports__